<template>
    <div ref="doublebookingmodal" class="booking-modal fixed w-full h-full top-0 left-0 flex items-center justify-center" style="z-index: 99">
        <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50" @click="toggleModal"></div>

        <div class="modal-container modal-bg-dark  md:max-w-4xl mx-auto rounded shadow-lg  overflow-y-auto" style="z-index: 99">

            <div class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm ">
                <span class="text-sm"></span>
            </div>

            <div class="modal-content py-4 text-left px-6" style="z-index: 99">
                <div class="flex justify-end items-center pb-3">
                    <div class="modal-close cursor-pointer" @click="toggleModal">
                        <svg class="fill-current text-gray-600" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                        </svg>
                    </div>
                </div>

                <div class="schedule-list w-full">
                    <div class="text-white m-4">
                        Det finns möjlighet att boka ett dubbelpass i anslutning till din bokning:
                    </div>
                    <div class="flex-1 flex-col text-white text-center bg-dark">
                        <div class="flex-1 text-sm">{{schedule.location.name}}</div>
                        <div class="flex-1 pb-2 text-sm">{{schedule.therapist.user ? schedule.therapist.user.name : ''}}</div>
                        <div class="flex-1 ">
                            {{formattedScheduleTimes(schedule)}}
                        </div>
                    </div>

                    <div class="flex flex-row mt-4 content-between">
                        <div class="flex flex-grow lg:px-4 sm:px-2 pb-2 justify-start">
                            <button class="bg-transparent rounded text-white border border-white px-8 cursor-default" @click="noDoubleBooking">
                                <span><i class="fa fa-ban"></i> {{transEdit('no_please')}}</span>
                            </button>
                        </div>
                        <div class="flex flex-grow lg:px-4 sm:px-2 pb-2 justify-end">
                            <button class="rounded btn-primary-dark px-8"
                                    @click="makeReservation">
                                {{transEdit('yes_please')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'double-booking',
        props: ['schedule'],
        data() {
            return {}
        },
        methods: {
            formattedScheduleTimes (schedule) {
                let start = moment(schedule.start);
                let end = moment(schedule.end);
                return start.format("HH:mm") + " - " + end.format("HH:mm");
            },
            toggleModal () {
                const body = document.querySelector('body');
                const modal = this.$refs["doublebookingmodal"];
                modal.classList.toggle('opacity-0');
                modal.classList.toggle('pointer-events-none');
                body.classList.toggle('modal-active');
            },
            makeReservation() {
                this.$emit('makeReservationById', this.schedule.id, true)
            },
            noDoubleBooking() {
                this.$emit('noDoubleBooking')
            }
        }
    }
</script>
<style>
    .btn-primary-dark {
        color: white;
        background-color: rgb(33, 114, 188);
    }
</style>